// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"314":"f897ddf2","750":"dc8d2d6b"}[chunkId] + ".chunk.js";
};